import { GDFPirep2Record } from '../../gdf/type';
import Pirep2Tooltip from '../tooltip/components/Pirep2Tooltip';

export default function PirepProperties({ record }: { record: GDFPirep2Record }) {
    return (
        <div style={{ maxWidth: 500 }}>
            <Pirep2Tooltip record={record} />
        </div>
    );
}
